import { GitHub, Call, WhatsApp } from '@material-ui/icons';
export const heroInfo = {
  name: 'A.Nalla Perumal',
  image: '/images/nalla.png',
  title: [
    'Full Stack Developer',
    'Freelancer',
    'MERN Stack Developer',
    'Laravel Developer',
    'Nextjs Developer',
    '3 Years Experience',
  ],
  contacts: [
    {
      id: 1,
      name: 'GitHub',
      icon: GitHub,
      username: 'nallaperumal007',
      link: 'https://github.com/nallaperumal007',
    },
    {
      id: 2,
      name: 'Contact',
      icon: Call, // replaced WhatsApp with Call
      username: 'Nalla perumal',
      link: 'https://wa.me/9094077295',
    },
    {
      id: 3,
      name: 'Contact',
      icon: WhatsApp,
      username: 'Nalla perumal',
      link: 'https://wa.me/9094077295',
    },
  ],
};

export const resumes = [
  {
    id: 1,
    year: 'March  2022 ',
    role: 'Web Developer',
    companyName: 'BRILLIANCE',
    companyUrl:
      'http://certificates-edu.s3.amazonaws.com/czoxMzoiNDQ1OTQxNF8xMDAwMiI7',
    description: 'Learn From This Course HTML,CSS,JAVASCRIPT',
  },
  {
    id: 2,
    year: 'May 2022- July 2023',
    role: 'Front-End-Developement',
    companyName: 'FreeCodeCamp',
    companyUrl:
      'https://www.freecodecamp.org/certification/fcc43de7d70-800c-46ba-ace8-ae0de50323bc/front-end-development-libraries',
    description:
      'Learn From This Course JQuery,Bootstrap,React,Redux,MaterialUI',
  },
];

export const educations = [
  // {
  //   id: 1,
  //   year: 'June 2023 - May 2025',
  //   universityName: 'St.Xaviers college',
  //   department: 'MCA',
  //   description: '',
  // },
  {
    id: 2,
    year: 'June 2020 - May 2023',
    universityName: 'St.xaviers college',
    department: 'Bachelor of Computer Application',
    description: '',
  },
  {
    id: 3,
    year: 'June 2019 - May 2020',
    universityName: 'St.xaviers school',
    department: 'Higher Secondary School Certificate',

    description: '',
  },
];
export const projects = [
  {
    id: 1,
    image: '/images/1.jpg',
    name: 'Finari',
    description: `Learn From This:
    1. React.js Core Concepts
    2. Redux for State Management
    3. Material UI Design Components
    4. API Integration Techniques
    5. Building Multiple Dashboards
    6. Data Analytics and Visualization`,
    tools: [
      'React',
      'Redux',
      'Material-UI',
      'API Integration',
      'Node.js',
      'Express.js',
      'Swagger',
      'MongoDB',
    ],
    live: 'https://www.finari.com/',
  },

  //   {
  //     id: 2,
  //     image: '/images/2.png',
  //     name: 'GMS Worldwide Express',
  //     description: `A Courier and Logistics Website featuring shipment tracking, customer login, service area listing, and dynamic shipping rate calculation. Built using ReactJS, Redux, Bootstrap (Frontend) and Core PHP, AJAX, jQuery (Backend).`,
  //     tools: ['react',  'bootstrap', 'corephp', 'ajax'],
  //     live: 'https://www.gmsworldwide.com/',
  //   }
  // ,
  {
    id: 2,
    image: '/images/5.jpg',
    name: 'Eticos - Hospital Management System',
    description: `Hospital Management System with patient registration, appointment scheduling, billing, and medical records management. Built using Next.js, TypeScript, Material UI, and integrated APIs.`,
    tools: ['Reactjs', 'Material UI', 'Nodejs', 'Expressjs', 'MongoDB'],
    live: 'https://token.etiicos.in/auth',
  },
  // {
  //   id: 4,
  //   image: '/images/4.png',
  //   name: 'Printrove Management System',
  //   description: `A web application built with Next.js for managing Printrove orders and products. It integrates Shopify for store management and uses TanStack Query for efficient data fetching and caching. Users can authenticate via Google Sign-In and manage posts globally, with or without images.`,
  //   tools: ['Next.js', 'TanStack Query', 'Shopify'],
  //   live: 'http://23.88.43.131:3001/auth/admin/login',
  // },
  // {
  //   id: 6,
  //   image: '/images/6.jpg',
  //   name: 'CsdExpress',
  //   description: `CsdExpress is a comprehensive courier management system designed to streamline parcel tracking, dispatching, and delivery operations. Built with a React frontend and a Laravel backend, it features Google Authentication for secure user access, and includes an intuitive admin dashboard with real-time analytics to monitor shipment status, delivery performance, and operational efficiency.`,
  //   tools: ['Laravel', 'mysql', 'bootstrap'],
  //   Demo: 'https://github.com/nallaperumal007/ReactFaceBookClone/assets/139489689/66b34b5c-bd2d-4277-b5a9-114ebccd9bdb',
  //   live: 'https://csdexpressllp.com/',
  // },
  {
    id: 3,
    image: '/images/7.jpg',
    name: 'SteadFast Groups',
    description: `SteadFast Groups is a chemical factory management platform built using Next.js and TypeScript. The system is designed to manage and monitor chemical production workflows, inventory, and safety compliance. It features a clean Material UI-based interface for ease of use and includes modules for batch tracking, quality checks, staff assignment, and real-time data visualization.`,
    tools: ['TypeScript', 'React.js', 'Material UI'],
    live: 'https://steadfastgroups.com/',
  },
  {
    id: 4,
    image: '/images/8.png',
    name: 'Cspocket',
    description: `CSpocket is a modern automotive and service platform built using Next.js and Firebase, offering a seamless and fast user experience.
Users can browse vehicles, book one-way cabs, request inspections, and hire acting drivers—all in one place.
The platform features real-time lead management, secure authentication, and smooth booking flows.
An intuitive admin panel enables easy management of products, services, orders, and customer data.`,
    tools: ['Next.js', 'Firebase', 'Material UI'],
    live: 'https://cspocket.in/',
  },
  {
    id: 5,
    image: '/images/10.png',
    name: 'IndieSpirit',
    description: `IndieSpirit is an Software development company website built using Nextjs  and Bootstrap. The platform showcases the company's services, portfolio, and team members through a sleek and responsive design.
     It features smooth animations powered by Gsap, enhancing user engagement and experience.
     The website is optimized for performance and accessibility, ensuring a seamless browsing experience across all devices.`,
    tools: ['Next.js', 'Bootstrap', 'Scss', 'Gsap'],
    live: 'https://indiespirit.com/',
  },
  {
    id: 6,
    image: '/images/12.jpg',
    name: 'Hratn',
    description: `Hratn is a cutting-edge social networking platform developed with Next.js and  Excel, designed to connect people through shared interests and activities.
It offers features such as user profiles, friend connections, event creation, and real-time messaging.
The platform emphasizes user engagement with interactive elements and a sleek, modern interface, making it easy for users to discover and join communities.
`,
    tools: ['Next.js', 'Excel', 'Material UI'],
    live: 'https://hratn.com/',
  },
  {
    id: 7,
    image: '/images/11.png',
    name: 'End2end',
    description: `End2end is a comprehensive logistics management platform built with Laravel and Mysql, designed to streamline shipping and delivery operations.
It offers real-time shipment tracking, order management, and route optimization features.
The platform includes a user-friendly interface for customers to book shipments and track deliveries, as well as an admin dashboard for managing operations efficiently.`,
    tools: ['Laravel', 'mysql', 'bootstrap'],
    live: 'https://www.end2endcargomovers.in/',
  },
  {
    id: 8,
    image: '/images/13.png',
    name: 'Harivara',
    description: `Harivara is an astrology website built using Laravel and Bootstrap. The platform offers a range of astrology services, including personalized horoscopes, tarot readings, and astrological consultations.
It features a user-friendly interface with smooth navigation and interactive elements, allowing users to easily access various services and resources. The website is designed to provide accurate astrological insights and guidance to users seeking spiritual and personal growth.
`,
    tools: ['Laravel', 'Bootstrap', 'Mysql'],
    live: 'https://harivara.com/',
  },
  {
    id: 9,
    image: '/images/14.png',
    name: 'E Sevai Maiyam',
    description: `E Sevai Maiyam is a government service portal built using Laravel and Bootstrap, designed to provide citizens with easy access to various public services and resources.
The platform features a user-friendly interface that allows users to navigate through different service categories, submit applications, and track the status of their requests.
It aims to streamline government-citizen interactions and enhance the efficiency of public service delivery.
`,
    tools: ['Laravel', 'Bootstrap', 'Mysql'],
    live: '#',
  },
];

export const skills = [
  {
    title: 'HTML',
    logo: 'https://www.vectorlogo.zone/logos/w3_html5/w3_html5-icon.svg',
  },
  {
    title: 'JavaScript',
    logo: 'https://www.vectorlogo.zone/logos/javascript/javascript-icon.svg',
  },
  {
    title: 'MongoDB',
    logo: 'https://www.vectorlogo.zone/logos/mongodb/mongodb-ar21.svg',
  },

  {
    title: 'CSS',
    logo: 'https://seeklogo.com/images/C/css3-logo-F1923C8D0E-seeklogo.com.png',
  },
  {
    title: 'TypeScript',
    logo: 'https://www.vectorlogo.zone/logos/typescriptlang/typescriptlang-icon.svg',
  },
  {
    title: 'Firebase',
    logo: 'https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg',
  },
  {
    title: 'Bootstrap',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/Bootstrap_logo.svg/512px-Bootstrap_logo.svg.png',
  },
  {
    title: 'ReactJS',
    logo: 'https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg',
  },
  // msql
  {
    title: 'MySQL',
    logo: 'https://seeklogo.com/images/M/mysql-logo-69B39F7D18-seeklogo.com.png',
  },

  {
    title: 'Angular',
    logo: 'https://www.vectorlogo.zone/logos/angular/angular-icon.svg',
  },

  {
    title: 'NodeJS',
    logo: 'https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg',
  },
  {
    title: 'PHP',
    logo: 'https://www.vectorlogo.zone/logos/php/php-icon.svg',
  },
  {
    title: 'Laravel',
    logo: 'https://www.vectorlogo.zone/logos/laravel/laravel-icon.svg',
  },

  {
    title: 'ExpressJS',
    logo: 'https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg',
  },

  {
    title: 'Git',
    logo: 'https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg',
  },
  {
    title: 'Linux',
    logo: 'https://www.freepnglogos.com/uploads/linux-png/file-icons-flat-linux-svg-wikimedia-commons-6.png',
  },
  {
    title: 'npm',
    logo: 'https://www.vectorlogo.zone/logos/npmjs/npmjs-icon.svg',
  },
  {
    title: 'GitHub',
    logo: 'https://www.vectorlogo.zone/logos/github/github-icon.svg',
  },
  {
    title: 'Netlify',
    logo: 'https://www.vectorlogo.zone/logos/netlify/netlify-icon.svg',
  },
  {
    title: 'Django',
    logo: 'https://www.vectorlogo.zone/logos/djangoproject/djangoproject-icon.svg',
  },
  {
    title: 'Java',
    logo: 'https://www.vectorlogo.zone/logos/java/java-icon.svg',
  },
  {
    title: 'Python',
    logo: 'https://www.vectorlogo.zone/logos/python/python-icon.svg',
  },
  {
    title: 'Jquery',
    logo: 'https://www.vectorlogo.zone/logos/jquery/jquery-icon.svg',
  },
  {
    title: 'Heroku',
    logo: 'https://www.vectorlogo.zone/logos/heroku/heroku-ar21.svg',
  },
];
